module.exports = __webpack_public_path__ + "static/media/mursaleen.7a0a3885.JPG";